import TextTag from "../Tag";
import "./index.css";
import { FiSlash, FiCloud, FiUser, FiHardDrive } from "react-icons/fi";

const BADGES = [
  { icon: <FiSlash size={16} />, label: "No ads" },
  { icon: <FiCloud size={16} />, label: "No cloud" },
  { icon: <FiUser size={16} />, label: "No accounts" },
  { icon: <FiHardDrive size={16} />, label: "Local storage only" },
];

const Privacy = () => {
  return (
    <section className="privacy">
      <div className="privacy__inner">
        <div className="privacy__left">
          <TextTag text="Data Privacy" />
          <h2 className="privacy__title">
            Your <span>data</span> stays with you
          </h2>
          <p className="privacy__sub">
            Habitime is built with one rule — your data is yours. Everything you
            log stays on your device. No accounts to create, no servers to
            trust, no ads to dodge. Just you and your habits.
          </p>
          <div className="privacy__badges">
            {BADGES.map(({ icon, label }) => (
              <div className="privacy__badge" key={label}>
                {icon}
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
